import { useNode } from '@craftjs/core';
import { FC, PropsWithChildren } from 'react';
import { FormImageComponent } from 'src/features/generalForms/builder/types/Image';
import { useFieldAttachments } from 'src/features/generalForms/context/attachments.provider';
import { Loading } from 'uikit/suspense/Loading';
import Style from './block.module.scss';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

import { ReactComponent as ImageGettingErrorPlaceholder } from 'assets/img/generalBuilder/no_image_placeholder_64.svg';

export const ImageBlock: FormImageComponent = () => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  const { imageUrl, loading, errorMessage } = useFieldAttachments();

  return (
    <div style={styles}>
      <ErrorPlaceholder errorMessage={errorMessage}>
        <Loading loading={loading} renderChildren={false} testId={'study-note-image-block'}>
          <img alt={'Custom image'} src={imageUrl} style={{ width: '100%' }} />
        </Loading>
      </ErrorPlaceholder>
    </div>
  );
};

const ErrorPlaceholder: FC<PropsWithChildren<{ errorMessage?: string }>> = ({ errorMessage, children }) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.ImageBlock');

  if (errorMessage)
    return (
      <div className={Style.imagePlaceholderContainer}>
        <ImageGettingErrorPlaceholder className={Style.imagePlaceholderIcon} />
        <span className={Style.imagePlaceholderText}>{t('LoadingError')}</span>
      </div>
    );

  return <>{children}</>;
};
